import card13 from './13.jpg';
import card1 from './1.jpg';
import card26 from './26.jpg';
import card14 from './14.jpg';
import card39 from './39.jpg';
import card27 from './27.jpg';
import card40 from './40.jpg';
import card52 from './52.jpg';
import card53 from './53.jpg';
import card65 from './65.jpg';
import card32 from './32.jpg';
import card4 from './4.jpg';
import card64 from './64.jpg';

const cards_data7 = [
    {
        image:card13,
    },
    {
        image:card1,
    },
    {
        image:card26,
    },
    {
        image:card14,
    },
    {
        image:card39,
    },
    {
        image:card27,
    },
    {
        image:card40,
    },
    {
        image:card52,
    },
    {
        image:card32,
    },
    {
        image:card65,
    },
    {
        image:card4,
    },
    {
        image:card53,
    },
    {
        image:card64,
    },
]

export default cards_data7;